import { Box } from "@mui/material";

type Props = {
  imageSrc: string;
  alt: string;
};

export const StoreBadgeImage = ({ imageSrc, alt }: Props) => (
  <Box component="img" src={imageSrc} alt={alt} height={40} display="block" />
);
